import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { openCookieConsent } from '../CookieConsent/CookieConsent';
import './Footer.css';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-inner">
                <p className="footer-org">Afrika-Link e.V.</p>
                <nav className="footer-nav">
                    <Link className="footer-link" to="/impressum" onClick={() => window.scroll(0, 0)}>
                        Impressum
                    </Link>
                    <Link className="footer-link" to="/datenschutz" onClick={() => window.scroll(0, 0)}>
                        Datenschutz
                    </Link>
                    <HashLink className="footer-link" to="/about#contact-section">
                        Kontakt
                    </HashLink>
                    <button type="button" className="footer-link footer-link--button" onClick={openCookieConsent}>
                        Cookie-Einstellungen
                    </button>
                    <Link className="footer-link" to="/signin" onClick={() => window.scroll(0, 0)}>
                        Team-Login
                    </Link>
                </nav>
                <p className="footer-copy">© {year} Afrika-Link e.V. Alle Rechte vorbehalten.</p>
            </div>
        </footer>
    );
};

export default Footer;
